// Auto-extracted from SellerAnalytics.jsx
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Icon } from "../../components/Icon";
import { fmtK, fmtKShort } from "../../lib/money";
import { resolveImage } from "../../lib/images";
import { DELIVERY_COLORS, DELIVERY_LABEL } from "./constants";

export function DeliveryDonut({ mix }) {
  const size = 160;
  const r = size / 2 - 10;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;
  let offset = 0;
  const total = mix.reduce((s, m) => s + m.count, 0);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke={C.cream} strokeWidth={18} />
        {mix.map((m, i) => {
          const dash = (m.pct / 100) * circumference;
          const gap = circumference - dash;
          const color = DELIVERY_COLORS[m.method] || C.dustDk;
          const circle = (
            <circle
              key={m.method}
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke={color}
              strokeWidth={18}
              strokeDasharray={`${dash} ${gap}`}
              strokeDashoffset={-offset}
              transform={`rotate(-90 ${cx} ${cy})`}
            />
          );
          offset += dash;
          return circle;
        })}
        <text x={cx} y={cy - 4} textAnchor="middle" fontSize={22} fontWeight={900} fill={C.charcoal}>
          {total}
        </text>
        <text x={cx} y={cy + 14} textAnchor="middle" fontSize={10} fontWeight={700} fill={C.muted}>
          orders
        </text>
      </svg>
      <div style={{ flex: 1, display: "grid", gap: 6 }}>
        {mix.map((m) => (
          <div key={m.method} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                background: DELIVERY_COLORS[m.method] || C.dustDk,
              }}
            />
            <div style={{ flex: 1, fontSize: 12, color: C.charcoal, fontWeight: 700 }}>
              {DELIVERY_LABEL[m.method] || m.method}
            </div>
            <div style={{ fontSize: 12, color: C.muted, fontWeight: 700 }}>
              {m.count} · {m.pct.toFixed(0)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
